var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog, ErrorMessageBox, FallbackComponent, TimezoneSelect } from '../../common';
import { LocationListPanel } from '../common/LocationListPanel';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { usePersistingLocationSelect } from '../common/usePersistingLocationSelect';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useLocationsAPI } from '../selectors';
import { CopyHoursModal } from './CopyHoursModal';
import { LocationConfigPanel } from './LocationConfigPanel';
import { SelectHolidaysModal } from './SelectHolidaysModal';
import { buildRegionLabel, groupHolidaysByName, inferLocationRegion, inferTimezoneIana, saveHqTimeZone, useCopyHoursFromAPI, useHolidayRegionsAPI, useHqTimeZoneAPI, useLocationHoursBatchAPI, useRegionHolidaysAPI, useSaveLocationHoursBatchAPI } from './selectors';
import { DEFAULT_DAYS, ORDERED_DAYS } from './types';
function buildDefaultHolidayState(location) {
  var _a, _b, _c, _d, _e;
  var inferred = inferLocationRegion(location.countryName, location.stateProvince);
  var countryCode = (_b = (_a = location.countryCode) !== null && _a !== void 0 ? _a : inferred === null || inferred === void 0 ? void 0 : inferred.countryCode) !== null && _b !== void 0 ? _b : 'CA';
  var regionCode = (_d = (_c = location.stateProvinceCode) !== null && _c !== void 0 ? _c : inferred === null || inferred === void 0 ? void 0 : inferred.regionCode) !== null && _d !== void 0 ? _d : '';
  return {
    autoApplyHolidays: Boolean((_e = location.autoApplyHolidays) !== null && _e !== void 0 ? _e : true),
    countryCode: countryCode,
    regionCode: regionCode,
    regionName: '',
    customHolidays: []
  };
}
function buildDefaultFormState(location) {
  var _a;
  var stored = location.timezone === 'UTC' ? null : location.timezone;
  var timezone = stored !== null && stored !== void 0 ? stored : inferTimezoneIana(location.countryName, (_a = location.stateProvinceCode) !== null && _a !== void 0 ? _a : location.stateProvince, location.countryCode);
  return {
    days: DEFAULT_DAYS.map(function (d) {
      return __assign({}, d);
    }),
    timezone: timezone,
    holiday: buildDefaultHolidayState(location)
  };
}
function buildFormStateFromLoadedData(data) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var location = data.location,
    hoursData = data.hoursData,
    holidayConfig = data.holidayConfig;
  var stored = location.timezone === 'UTC' ? null : location.timezone;
  var timezone = stored !== null && stored !== void 0 ? stored : inferTimezoneIana(location.countryName, (_a = location.stateProvinceCode) !== null && _a !== void 0 ? _a : location.stateProvince, location.countryCode);
  var inferred = inferLocationRegion(location.countryName, location.stateProvince);
  var countryCode = (_d = (_c = (_b = holidayConfig.countryCode) !== null && _b !== void 0 ? _b : location.countryCode) !== null && _c !== void 0 ? _c : inferred === null || inferred === void 0 ? void 0 : inferred.countryCode) !== null && _d !== void 0 ? _d : 'CA';
  var regionCode = (_g = (_f = (_e = holidayConfig.regionCode) !== null && _e !== void 0 ? _e : location.stateProvinceCode) !== null && _f !== void 0 ? _f : inferred === null || inferred === void 0 ? void 0 : inferred.regionCode) !== null && _g !== void 0 ? _g : '';
  var storedActive = ((_h = holidayConfig.holidays) !== null && _h !== void 0 ? _h : []).filter(function (h) {
    return h.isActive;
  });
  var customHolidays = storedActive.map(function (h) {
    return {
      date: h.date,
      name: h.name
    };
  });
  var days = ORDERED_DAYS.map(function (d) {
    var _a, _b;
    var dayData = hoursData.find(function (h) {
      return h.dayOfWeek === d.key;
    });
    return {
      dayOfWeek: d.key,
      isAvailable: Boolean(dayData === null || dayData === void 0 ? void 0 : dayData.isAvailable),
      startTime: (_a = dayData === null || dayData === void 0 ? void 0 : dayData.startTime) !== null && _a !== void 0 ? _a : null,
      endTime: (_b = dayData === null || dayData === void 0 ? void 0 : dayData.endTime) !== null && _b !== void 0 ? _b : null
    };
  });
  return {
    days: days,
    timezone: timezone,
    holiday: {
      autoApplyHolidays: Boolean((_j = holidayConfig.autoApplyHolidays) !== null && _j !== void 0 ? _j : true),
      countryCode: countryCode,
      regionCode: regionCode,
      regionName: '',
      customHolidays: customHolidays
    }
  };
}
function buildSaveHolidayPayload(holiday) {
  var countryCode = holiday.countryCode,
    regionCode = holiday.regionCode;
  var holidayRegion;
  if (countryCode) {
    holidayRegion = countryCode;
    if (regionCode) {
      holidayRegion = "".concat(regionCode, ": ").concat(countryCode);
    }
  }
  var customHolidays = holiday.customHolidays.map(function (h) {
    return {
      holidayDate: h.date,
      holidayName: h.name,
      isActive: true,
      holidayRegion: holidayRegion
    };
  });
  return {
    autoApplyHolidays: Boolean(holiday.autoApplyHolidays),
    countryCode: holiday.countryCode || undefined,
    regionCode: holiday.regionCode || undefined,
    customHolidays: customHolidays
  };
}
function buildLocationSavePayload(loc, fm) {
  var _a;
  var form = fm[loc.id];
  var days = form.days.map(function (d) {
    return d.isAvailable && d.startTime && d.endTime ? d : __assign(__assign({}, d), {
      isAvailable: false,
      startTime: null,
      endTime: null
    });
  });
  return {
    locationId: loc.id,
    days: days,
    holidays: buildSaveHolidayPayload(form.holiday),
    timezone: (_a = form.timezone) !== null && _a !== void 0 ? _a : null
  };
}
export var HoursStep = function () {
  var _a, _b, _c;
  var _d = useContext(OrgConfigWizardContext),
    configVersionId = _d.configVersionId,
    setBeforeNext = _d.setBeforeNext,
    selectedLocationId = _d.selectedLocationId,
    setSelectedLocationId = _d.setSelectedLocationId,
    isReadOnly = _d.isReadOnly;
  var _e = useTranslation('orgConfig', {
      keyPrefix: 'hours'
    }),
    t = _e.t,
    i18n = _e.i18n;
  var tCountry = useTranslation('countries').t;
  var _f = useLocationHoursBatchAPI(configVersionId),
    batchData = _f[0],
    fetchBatch = _f[1],
    clearBatchData = _f[2];
  var _g = useSaveLocationHoursBatchAPI(),
    saveBatchData = _g[0],
    doSaveBatch = _g[1],
    clearSaveBatch = _g[2];
  var pendingSaveRef = useRef(null);
  var _h = useCopyHoursFromAPI(selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0),
    copyData = _h[0],
    doCopyFrom = _h[1],
    clearCopyData = _h[2];
  var _j = useState(false),
    clearConfirmOpen = _j[0],
    setClearConfirmOpen = _j[1];
  var _k = useLocationsAPI(configVersionId),
    locationsData = _k[0],
    fetchLocations = _k[1];
  var allLocations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  useEffect(function () {
    if (configVersionId) fetchLocations();
  }, [configVersionId, fetchLocations]);
  var _l = useHqTimeZoneAPI(configVersionId),
    hqTimeZoneData = _l[0],
    fetchHqTimeZone = _l[1];
  var _m = useState(null),
    hqTimeZone = _m[0],
    setHqTimeZone = _m[1];
  var _o = useState(null),
    headerRightEl = _o[0],
    setHeaderRightEl = _o[1];
  useEffect(function () {
    setHeaderRightEl(document.getElementById('org-config-hours-header-top-right'));
  }, []);
  useEffect(function () {
    if (configVersionId) fetchHqTimeZone();
  }, [configVersionId, fetchHqTimeZone]);
  useEffect(function () {
    var _a, _b;
    setHqTimeZone((_b = (_a = hqTimeZoneData.data) === null || _a === void 0 ? void 0 : _a.hqTimeZone) !== null && _b !== void 0 ? _b : null);
  }, [hqTimeZoneData.data]);
  var selectedLocation = useMemo(function () {
    var _a;
    return (_a = allLocations.find(function (l) {
      return l.id === selectedLocationId;
    })) !== null && _a !== void 0 ? _a : null;
  }, [allLocations, selectedLocationId]);
  var _p = useState({}),
    formMap = _p[0],
    setFormMap = _p[1];
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var loading = !!batchData.requesting;
  var _q = useState(new Set()),
    validationErrors = _q[0],
    setValidationErrors = _q[1];
  var _r = useState(undefined),
    globalError = _r[0],
    setGlobalError = _r[1];
  var handleHqTimeZoneChange = useCallback(function (value) {
    if (!value || value === hqTimeZone) return;
    var previous = hqTimeZone;
    setHqTimeZone(value);
    saveHqTimeZone(configVersionId, value).catch(function () {
      setHqTimeZone(previous);
      setGlobalError({
        message: t('hqTimezone.saveFailed', {
          defaultValue: 'Failed to save the HQ time zone.'
        })
      });
    });
  }, [configVersionId, hqTimeZone, t]);
  var configuredLocationIds = useMemo(function () {
    var ids = new Set();
    for (var _i = 0, _a = Object.entries(formMap); _i < _a.length; _i++) {
      var _b = _a[_i],
        idStr = _b[0],
        form = _b[1];
      var id = Number(idStr);
      var hasTimezone = !!form.timezone;
      var hasHours = form.days.some(function (d) {
        return d.isAvailable && d.startTime && d.endTime;
      });
      if (hasTimezone && hasHours) ids.add(id);
    }
    return ids;
  }, [formMap]);
  var getLocationStatus = useCallback(function (id) {
    if (validationErrors.has(id)) return 'error';
    if (configuredLocationIds.has(id)) return 'ok';
    return 'incomplete';
  }, [validationErrors, configuredLocationIds]);
  var baselineFormMapRef = useRef({});
  useEffect(function () {
    if (configVersionId) fetchBatch();
  }, [configVersionId, fetchBatch]);
  useEffect(function () {
    if (!batchData.data || !allLocations.length) return;
    setFormMap(function (prev) {
      var _a;
      var next = __assign({}, prev);
      var changed = false;
      var newBaseline = __assign({}, baselineFormMapRef.current);
      var _loop_1 = function (item) {
        var location_1 = allLocations.find(function (l) {
          return l.id === item.locationId;
        });
        if (!location_1) return "continue";
        var newForm = buildFormStateFromLoadedData({
          locationId: item.locationId,
          location: __assign(__assign({}, location_1), {
            countryName: tCountry(location_1.countryName, {
              defaultValue: location_1.countryName
            })
          }),
          hoursData: item.hours,
          holidayConfig: item.holidays
        });
        if (!newBaseline[item.locationId]) {
          newBaseline[item.locationId] = newForm;
        }
        if (!next[item.locationId]) {
          next[item.locationId] = newForm;
          changed = true;
        }
      };
      for (var _i = 0, _b = (_a = batchData === null || batchData === void 0 ? void 0 : batchData.data) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++) {
        var item = _b[_i];
        _loop_1(item);
      }
      baselineFormMapRef.current = newBaseline;
      return changed ? next : prev;
    });
  }, [batchData.data, allLocations, tCountry]);
  var updateForm = useCallback(function (locationId, updater) {
    setFormMap(function (prev) {
      var _a;
      var _b;
      var found = allLocations.find(function (l) {
        return l.id === locationId;
      });
      var current = (_b = prev[locationId]) !== null && _b !== void 0 ? _b : found ? buildDefaultFormState(__assign(__assign({}, found), {
        countryName: tCountry(found.countryName, {
          defaultValue: found.countryName
        })
      })) : null;
      if (!current) return prev;
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = updater(current), _a));
    });
    setValidationErrors(function (prev) {
      var next = new Set(prev);
      next.delete(locationId);
      return next;
    });
  }, [allLocations, tCountry]);
  var currentForm = selectedLocationId !== null && selectedLocationId !== undefined ? (_a = formMap[selectedLocationId]) !== null && _a !== void 0 ? _a : null : null;
  var updateDay = useCallback(function (dayKey, updater) {
    if (!selectedLocationId) return;
    updateForm(selectedLocationId, function (prev) {
      return __assign(__assign({}, prev), {
        days: prev.days.map(function (d) {
          return d.dayOfWeek === dayKey ? updater(d) : d;
        })
      });
    });
  }, [selectedLocationId, updateForm]);
  var _s = useState(null),
    copyModalDay = _s[0],
    setCopyModalDay = _s[1];
  var handleCopyConfirm = useCallback(function (targetDays) {
    if (!selectedLocationId || !copyModalDay || !currentForm) return;
    var sourceDay = currentForm.days.find(function (d) {
      return d.dayOfWeek === copyModalDay;
    });
    if (!sourceDay) return;
    updateForm(selectedLocationId, function (prev) {
      return __assign(__assign({}, prev), {
        days: prev.days.map(function (d) {
          if (!targetDays.includes(d.dayOfWeek)) return d;
          return __assign(__assign({}, d), {
            isAvailable: true,
            startTime: sourceDay.startTime,
            endTime: sourceDay.endTime
          });
        })
      });
    });
    setCopyModalDay(null);
  }, [selectedLocationId, copyModalDay, currentForm, updateForm]);
  var _t = useState(false),
    holidaysModalOpen = _t[0],
    setHolidaysModalOpen = _t[1];
  var handleHolidaysSave = useCallback(function (selectedHolidays) {
    if (!selectedLocationId) return;
    updateForm(selectedLocationId, function (prev) {
      return __assign(__assign({}, prev), {
        holiday: __assign(__assign({}, prev.holiday), {
          customHolidays: selectedHolidays,
          // The modal selection is authoritative: any holidays → auto-apply on; none (deselect all) → off.
          autoApplyHolidays: selectedHolidays.length > 0
        })
      });
    });
    setHolidaysModalOpen(false);
  }, [selectedLocationId, updateForm]);
  var currentCountryCode = (_b = currentForm === null || currentForm === void 0 ? void 0 : currentForm.holiday.countryCode) !== null && _b !== void 0 ? _b : 'CA';
  var currentRegionCode = (_c = currentForm === null || currentForm === void 0 ? void 0 : currentForm.holiday.regionCode) !== null && _c !== void 0 ? _c : '';
  var _u = useHolidayRegionsAPI(currentCountryCode),
    regionsData = _u[0],
    fetchRegions = _u[1];
  useEffect(function () {
    if (currentCountryCode) fetchRegions();
  }, [currentCountryCode, fetchRegions]);
  var regions = useMemo(function () {
    var _a;
    return (_a = regionsData.data) !== null && _a !== void 0 ? _a : [];
  }, [regionsData.data]);
  // Library holidays for the selected region, used to show the count of holidays in effect
  // while the toggle is on but the user hasn't made an explicit selection (auto-apply mode).
  var _v = useRegionHolidaysAPI(currentCountryCode, currentRegionCode),
    regionHolidaysData = _v[0],
    fetchRegionHolidays = _v[1];
  useEffect(function () {
    if (currentCountryCode) fetchRegionHolidays();
  }, [currentCountryCode, currentRegionCode, fetchRegionHolidays]);
  var regionHolidayCount = useMemo(function () {
    var _a;
    return groupHolidaysByName((_a = regionHolidaysData.data) !== null && _a !== void 0 ? _a : []).length;
  }, [regionHolidaysData.data]);
  // Distinct holidays in effect: an explicit selection wins; otherwise auto-apply means all
  // region holidays; toggling off means none.
  var effectiveHolidayCount = useMemo(function () {
    var holiday = currentForm === null || currentForm === void 0 ? void 0 : currentForm.holiday;
    if (!holiday) return 0;
    if (holiday.customHolidays.length > 0) return groupHolidaysByName(holiday.customHolidays).length;
    return holiday.autoApplyHolidays ? regionHolidayCount : 0;
  }, [currentForm, regionHolidayCount]);
  // When regions load for the selected location, resolve regionCode from stateProvinceCode if not already set.
  useEffect(function () {
    var _a;
    if (!regions.length || !selectedLocationId || !selectedLocation) return;
    var form = formMap[selectedLocationId];
    if (!form || form.holiday.regionCode) return;
    var directCode = (_a = selectedLocation.stateProvinceCode) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase();
    if (!directCode) return;
    var match = regions.find(function (r) {
      return r.code.toUpperCase() === directCode;
    });
    if (!match) return;
    updateForm(selectedLocationId, function (prev) {
      return __assign(__assign({}, prev), {
        holiday: __assign(__assign({}, prev.holiday), {
          regionCode: match.code
        })
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions, selectedLocationId, updateForm]);
  var allLocationsRef = useRef(allLocations);
  useEffect(function () {
    allLocationsRef.current = allLocations;
  }, [allLocations]);
  useEffect(function () {
    if (!pendingSaveRef.current) return;
    if (saveBatchData.requesting) return;
    if (saveBatchData.error) {
      setGlobalError({
        message: t('errors.saveFailed')
      });
      pendingSaveRef.current.resolve(false);
      pendingSaveRef.current = null;
      clearSaveBatch();
    } else if (saveBatchData.statusCode !== undefined) {
      baselineFormMapRef.current = formMapRef.current;
      pendingSaveRef.current.resolve(true);
      pendingSaveRef.current = null;
      clearSaveBatch();
    }
  }, [saveBatchData.requesting, saveBatchData.error, saveBatchData.statusCode, clearSaveBatch, t]);
  var clearBatchDataRef = useRef(clearBatchData);
  useEffect(function () {
    clearBatchDataRef.current = clearBatchData;
  }, [clearBatchData]);
  useEffect(function () {
    return function () {
      var _a;
      if (pendingSaveRef.current) {
        pendingSaveRef.current.resolve(false);
        pendingSaveRef.current = null;
      }
      (_a = clearBatchDataRef.current) === null || _a === void 0 ? void 0 : _a.call(clearBatchDataRef);
    };
  }, []);
  var checkIsDirty = useCallback(function () {
    return JSON.stringify(formMap) !== JSON.stringify(baselineFormMapRef.current);
  }, [formMap]);
  useOrgConfigDirtyRegister(checkIsDirty);
  var doSaveBatchRef = useRef(doSaveBatch);
  useEffect(function () {
    doSaveBatchRef.current = doSaveBatch;
  }, [doSaveBatch]);
  var persistHours = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var fm, isDataLoaded, locations;
      return __generator(this, function (_a) {
        fm = formMapRef.current;
        isDataLoaded = !batchData.requesting && !!batchData.data;
        if (!isDataLoaded || !checkIsDirty()) return [2 /*return*/, true];
        setGlobalError(undefined);
        locations = allLocationsRef.current.filter(function (loc) {
          return !!fm[loc.id];
        }).map(function (loc) {
          return buildLocationSavePayload(loc, fm);
        });
        if (locations.length === 0) return [2 /*return*/, true];
        return [2 /*return*/, new Promise(function (resolve) {
          pendingSaveRef.current = {
            resolve: resolve
          };
          doSaveBatchRef.current({
            locations: locations
          });
        })];
      });
    });
  }, [batchData.requesting, batchData.data, checkIsDirty]);
  useEffect(function () {
    setBeforeNext(persistHours);
    return function () {
      return setBeforeNext(null);
    };
  }, [setBeforeNext, persistHours]);
  useEffect(function () {
    var item = copyData.data;
    if (!item || !selectedLocationId) return;
    var location = allLocations.find(function (l) {
      return l.id === selectedLocationId;
    });
    if (!location) return;
    setFormMap(function (prev) {
      var _a;
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = buildFormStateFromLoadedData({
        locationId: selectedLocationId,
        location: __assign(__assign({}, location), {
          countryName: tCountry(location.countryName, {
            defaultValue: location.countryName
          })
        }),
        hoursData: item.hours,
        holidayConfig: item.holidays
      }), _a));
    });
    clearCopyData();
  }, [copyData.data, selectedLocationId, allLocations, clearCopyData, tCountry]);
  var handleCopyFrom = useCallback(function (sourceLocationId) {
    doCopyFrom({
      sourceLocationId: sourceLocationId
    });
  }, [doCopyFrom]);
  var handleClearData = useCallback(function () {
    if (!selectedLocationId || !selectedLocation) return;
    setFormMap(function (prev) {
      var _a;
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = buildDefaultFormState(__assign(__assign({}, selectedLocation), {
        countryName: tCountry(selectedLocation.countryName, {
          defaultValue: selectedLocation.countryName
        })
      })), _a));
    });
  }, [selectedLocationId, selectedLocation, tCountry]);
  var onSelectLocation = usePersistingLocationSelect({
    selectedLocationId: selectedLocationId,
    setSelectedLocationId: setSelectedLocationId,
    persistCurrent: persistHours
  }).onSelectLocation;
  return _jsxs(_Fragment, {
    children: [headerRightEl && createPortal(_jsxs(Stack, __assign({
      direction: "row",
      alignItems: "center",
      gap: 2
    }, {
      children: [_jsx(Typography, __assign({
        noWrap: true
      }, {
        children: t('hqTimezone.title', {
          defaultValue: 'HQ Time Zone:'
        })
      })), _jsx(TimezoneSelect, {
        value: hqTimeZone,
        onChange: handleHqTimeZoneChange,
        fullWidth: false,
        disabled: isReadOnly,
        sx: {
          width: '16rem',
          mb: 0
        }
      })]
    })), headerRightEl), _jsx(ErrorMessageBox, {
      errors: [batchData.error, copyData.error, globalError],
      onClose: function () {
        return setGlobalError(undefined);
      }
    }), _jsx(OrgConfigStepContainer, __assign({
      leftContent: _jsx(LocationListPanel, {
        allLocations: allLocations,
        selectedLocationId: selectedLocationId,
        onSelectLocation: onSelectLocation,
        getLocationStatus: getLocationStatus
      })
    }, {
      children: !selectedLocation || !currentForm ? _jsx(FallbackComponent, __assign({
        requesting: loading
      }, {
        children: _jsx(Box, __assign({
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 300
          }
        }, {
          children: _jsx(Typography, __assign({
            color: "text.secondary"
          }, {
            children: t('schedule.selectLocation')
          }))
        }))
      })) : _jsx(LocationConfigPanel, {
        currentForm: currentForm,
        selectedLocationId: selectedLocationId,
        allLocations: allLocations,
        regions: regions,
        currentCountryCode: currentCountryCode,
        holidayCount: effectiveHolidayCount,
        updateForm: updateForm,
        updateDay: updateDay,
        onCopyDayClick: setCopyModalDay,
        onOpenHolidaysModal: function () {
          return setHolidaysModalOpen(true);
        },
        onCopyFrom: handleCopyFrom,
        onClear: function () {
          return setClearConfirmOpen(true);
        },
        isCopying: !!copyData.requesting
      })
    })), _jsx(CopyHoursModal, {
      open: copyModalDay !== null,
      sourceDay: copyModalDay !== null && copyModalDay !== void 0 ? copyModalDay : '',
      onClose: function () {
        return setCopyModalDay(null);
      },
      onConfirm: handleCopyConfirm
    }), _jsx(ConfirmDialog, {
      open: clearConfirmOpen,
      onClose: function () {
        return setClearConfirmOpen(false);
      },
      title: t('clearDataTitle', {
        defaultValue: 'Clear hours data?'
      }),
      message: t('clearDataMessage', {
        defaultValue: 'Are you sure you want to clear all hours data for this location?'
      }),
      onConfirm: function () {
        handleClearData();
        setClearConfirmOpen(false);
      }
    }), currentForm && selectedLocation && _jsx(SelectHolidaysModal, {
      open: holidaysModalOpen,
      regionName: buildRegionLabel(currentForm.holiday.countryCode, currentForm.holiday.regionCode, regions, i18n === null || i18n === void 0 ? void 0 : i18n.language),
      countryCode: currentForm.holiday.countryCode,
      regionCode: currentForm.holiday.regionCode,
      preSelectAll: currentForm.holiday.autoApplyHolidays && currentForm.holiday.customHolidays.length === 0,
      preSelectedHolidays: currentForm.holiday.customHolidays,
      onClose: function () {
        return setHolidaysModalOpen(false);
      },
      onSave: handleHolidaysSave
    })]
  });
};